import { Component, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-upload-task-list',
  templateUrl: './upload-task-list.component.html',
  styleUrls: ['./upload-task-list.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class UploadTaskListComponent {
  @Input() taskList = [];
  @Output() closeClick = new EventEmitter();
  @Output() retryClick = new EventEmitter();
  @Output() removeClick = new EventEmitter<string>();

  updates = [];
  collapsed = false;

  get uploading() {
    const totalCount = this.taskList.length;
    const finishedCount = this.taskList.filter(({ current }) => current >= 100).length;

    return !(totalCount === finishedCount);
  }

  get title() {
    const plural = this.taskList.length > 1 ? 's' : '';
    if (this.uploading) {
      const description = `Fazendo upload do${plural} arquivo${plural}`;
      return `${description.substring(0, 30)}...`;
    }

    return `Upload${plural} concluído${plural}`;
  }

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }

  close() {
    this.closeClick.emit({
      unfinished: this.uploading,
    });
  }

  remove(filenameEvent: string) {
    this.removeClick.emit(filenameEvent);
  }

  retry(filenameEvent: string) {
    this.retryClick.emit(filenameEvent);
  }
}
